import React, { FC, useState } from 'react';
import CustomModal from '../../components/CustomModal';
import ProjectForm from '../../components/ProjectForm/index';
import NewUnitTabs from '../../components/NewUnitTabs';
import useTranslation from '../../hooks/useTranslation';
import { ProjectTypeModalProps } from '../../models/reusableProps/ProjectTypeModalProps';
import { useTypedSelector } from '../../store';
import {
  getBusinessUnits,
  getSelectedCountryCodes,
} from '../../store/selectData/selectors';
import { selectResponsibleOptionsList } from '../../store/users/selectors';
import { useDispatch } from 'react-redux';
import {
  createProject,
  fetchSiteLocation,
} from '../../store/projects/actionWrapper';
import { ESTABLISHMENT_TYPE } from '../../components/ProjectTypeSelect/utils';
import { selectConfidentialPermission } from '../../store/userData/selectors';
import { returnNewUnitValidationSchema, calculateTabErrors } from './utils';
import { selectSiteLocation } from '../../store/projects/selectors';

const CreateNewUnitModal: FC<ProjectTypeModalProps> = ({
  visible,
  onClose,
  projectsList,
  countries,
  setActiveProject,
  projectCreatedTrigger,
}) => {
  const t = useTranslation();
  const isConfidentialAllowed = useTypedSelector(selectConfidentialPermission);
  const usersList = useTypedSelector(selectResponsibleOptionsList);
  const BuList = useTypedSelector(getBusinessUnits);
  const selectedCountryCodes = useTypedSelector(getSelectedCountryCodes);
  const [selectedCountry, setSelectedCountry] = React.useState('');
  const validation = returnNewUnitValidationSchema(t);
  const selectedSiteLocation = useTypedSelector(selectSiteLocation);
  const dispatch = useDispatch();
  const [formModified, setFormModified] = React.useState(false);
  const [formErrors, setFormErrors] = useState({});

  const handleCreateProject = (props) => {
    dispatch(
      createProject({
        ...props,
        establishmentType: ESTABLISHMENT_TYPE.NEW_UNIT,
      }),
    );
    projectCreatedTrigger();
    onClose();
  };
  const onCountryChange = (country) => {
    setSelectedCountry(country.target.value);
  };

  const onBUChange = (bu) => {
    dispatch(fetchSiteLocation(bu.businessUnitId || ''));
  };

  const BuFiltered = BuList.filter(
    (bu) =>
      bu.countryId === (selectedCountry || selectedCountryCodes[0]?.countryId),
  );
  return (
    <CustomModal
      isVisible={visible}
      formModified={formModified}
      testid={'create-new-unit-modal'}
      useConfirmation
      onClose={onClose}
      title={t('actions.createNewUnit')}
      children={
        <ProjectForm
          onSubmit={handleCreateProject}
          setFormModified={(isDirty) => setFormModified(isDirty)}
          country={selectedCountryCodes[0]?.countryId || ''}
          onClose={onClose}
          submitBtnTitle={t('common.create')}
          validationSchema={validation}
          selectedSiteLocation={selectedSiteLocation}
          projectType={ESTABLISHMENT_TYPE.NEW_UNIT}
          setFormErrors={setFormErrors}
        >
          <NewUnitTabs
            onCountryChange={onCountryChange}
            projectsList={projectsList}
            countries={countries}
            setActiveProject={setActiveProject}
            usersList={usersList}
            isConfidentialAllowed={isConfidentialAllowed}
            onBUChange={onBUChange}
            BuList={BuFiltered}
            tabErrors={calculateTabErrors(formErrors, false)}
          />
        </ProjectForm>
      }
    />
  );
};

export default CreateNewUnitModal;
